import { createTheme } from '@mui/material/styles';

export const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1976d2', // 蓝色
    },
    secondary: {
      main: '#9c27b0', // 紫色
    },
    error: {
      main: '#d32f2f', // 红色
    },
    background: {
      default: '#fff',
      paper: '#fff',
    },
  },
});

export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#90caf9', // 浅蓝
    },
    secondary: {
      main: '#f48fb1', // 粉色
    },
    error: {
      main: '#f44336', // 红色
    },
    background: {
      default: '#121212',
      paper: '#121212',
    },
  },
});